import { render, staticRenderFns } from "./page-building-repairer.vue?vue&type=template&id=42f8034c&scoped=true&"
import script from "./page-building-repairer.vue?vue&type=script&lang=js&"
export * from "./page-building-repairer.vue?vue&type=script&lang=js&"
import style0 from "./page-building-repairer.vue?vue&type=style&index=0&id=42f8034c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f8034c",
  null
  
)

export default component.exports